import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyFaceDetectionAPI } from "../../../Services/ApiTestService/apiTestService";
import { Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";
import { MdDelete } from "react-icons/md";


const FaceDetection = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [detectionData, setDetectionData] = useState({});
  const [showDetectionData , setShowDetectionData] = useState(false);
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const { serviceName } = useService();

  const [person, setPerson] = useState(null);
  const [preview, setPreview] = useState(null);



  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);


const validateForm = (person) => {
  const errors = {};
  if (!person) {
    errors.person = "Image is required.";
  } 
  return errors;
};


  
const handleSubmit = async () => {
  const validationErrors = validateForm(person);
  setErrors(validationErrors);
  if (Object.keys(validationErrors).length > 0) return;
  // console.log(person)

  try {
    setIsLoading(true);

    const response = await verifyFaceDetectionAPI({
      api_id: profileData?.user_id,
      api_key: profileData?.api_key,
      token_id: profileData?.token_id,
      personFile : person,
    });

  //  console.log("response" , response)

    const statusCode = response?.status?.code || response?.status;

    if (statusCode === 200) {
   
const rcData = response?.data;

if (rcData && typeof rcData === "object") {
  setDetectionData(rcData);
  setShowDetectionData(true);

  if (rcData.is_live) {
    showSuccessToast("Face Detected successfully.");
  } else {
    showErrorToast("Face not Detected.");
  }

  setPerson(null);
  setErrors({});
} else {
  showErrorToast("Unexpected API format.");
}

}

    else if (statusCode === 422) {
      showErrorToast(response.data.message || "Invalid format");
    } 
    
    else if (statusCode === 500) {
      showErrorToast(response.data.message || "Server error");
    } 
    
    else {
      showErrorToast(response.status?.message || "Something went wrong");
    }

  } catch (error) {
    console.error("Face Detection API Error:", error);
    showErrorToast("Failed to verify face detection.");
  } finally {
    setIsLoading(false);
  }
};


  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:ml-80 ml-0 p-4">
       
      <div className="col-span-2 md:col-span-6 flex justify-end">
        <Link
            to="/TestMaster"
            className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
        >
            <span>Go Back</span>
            <IoArrowBackCircleOutline size={24} />
        </Link>
    </div>

        <div className="flex flex-col justify-center items-center">

          {/* input box */}
            <div className="flex justify-center items-center">

                    {/* start drag and drop */}
                            <div className="w-60 h-60 p-4 bg-white shadow-sm rounded-md md:ml-[280px]">
                            <div
                                className="flex flex-col items-center justify-center h-full border-2 border-dashed border-blue-300 rounded-md cursor-pointer hover:bg-blue-50 transition"
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={(e) => {
                                e.preventDefault();
                                const file = e.dataTransfer.files[0];

                                if (!file || !file.type.startsWith("image/")) {
                                    return;
                                }

                                setPerson(file);
                                setPreview(URL.createObjectURL(file));
                                }}
                                onClick={() => document.getElementById("personHiddenInput").click()}
                            >
                                {!preview ? (
                                <>
                                    <p className="text-sm text-gray-600 text-center">
                                    Drag & drop person image here
                                    </p>
                                    <p className="text-xs text-gray-400 mt-1">or click to browse</p>
                                </>
                                ) : (
                                <div className="relative w-44 h-44">
                                  <img
                                      src={preview}
                                      alt="Person Preview"
                                      className="w-full h-full object-cover rounded-md"
                                      />
                                    <MdDelete size={16} className="absolute top-1 right-0 z-10 hover:text-red-500" onClick={(e) => {
                                      e.stopPropagation();
                                      setPreview(null);
                                      setPerson(null);
                                    }}/>
                                </div>
                                )}
                            </div>

                            {/* Hidden file input (for click fallback) */}
                            <input
                                type="file"
                                id="personHiddenInput"
                                accept="image/*"
                                hidden
                                onChange={(e) => {
                                const file = e.target.files[0];
                                if (!file) return;

                                setPerson(file);
                                setPreview(URL.createObjectURL(file));
                                }}
                            />

                            {errors.person && (
                                <p className="text-xs text-red-500 mt-1">{errors.person}</p>
                            )}
                            </div>
                    {/* end drag and drop */}

            </div>

            {/* verify button */}
                <div>
                    <Button
                    type="button"
                    className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 md:ml-[280px] text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                    id="verifyRC"
                    name="verifyRC"
                    text="Verify"
                    onClick={handleSubmit}
                    />
                </div>

        </div>


      </div>

    {/* instructions */}
    <div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-3 mb-6">
    <h2 class="text-xl font-bold text-center text-gray-800 mb-2">Face Detection Verification Steps</h2>

    <ol class="list-decimal list-inside text-gray-700 space-y-1">
        <li>Upload your clear photo.</li>
        <li>Click on "Verify" to check face detection of a person.</li>
    </ol>

    <div class="mt-2">
        <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
        <ul class="list-disc list-inside text-gray-600 space-y-1">
        <li>Do not refresh the page during the verification process.</li>
        </ul>
    </div>
    </div>

    {/* response of API */}
    {showDetectionData && detectionData && typeof detectionData === "object" && (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-4">

        {/* Face Detection Summary */}
        <div className="bg-gradient-to-br from-green-50 to-white border border-green-200 rounded-2xl shadow-xl p-4">
        <h3 className="text-green-800 font-semibold text-xl">
            Face Detection Result
        </h3>

        <div className="text-sm text-gray-700 mt-3 space-y-1">
            <p>
            <strong>Eye Closed:</strong>{" "}
            {detectionData.eye_closed ? (
                <span className="text-green-600 font-semibold">True</span>
            ) : (
                <span className="text-red-600 font-semibold">False</span>
            )}
            </p>

            <p>
            <strong>Liveness Confidence:</strong>{" "}
            {(detectionData.liveness_confidence * 100).toFixed(2)}%
            </p>

            <p>
            <strong>Is Live:</strong>{" "}
            {detectionData.is_live ? "True" : "False"}
            </p>

            <p>
            <strong>Face Occulded:</strong>{" "}
            {detectionData.is_face_occluded ? "True" : "False"}
            </p>

            <p>
            <strong>Occulsion Confidence:</strong>{" "}
            {detectionData.occlusion_confidence ? "1" : "0"}
            </p>

            <p>
            <strong>Multiple Face Detected:</strong>{" "}
            {detectionData.multiple_face_detected ? "Yes" : "No"}
            </p>
        </div>
        </div>

        {/* Raw JSON Preview */}
        <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-4">
        <h3 className="text-blue-800 font-semibold text-xl mb-2">
            API Response (Raw)
        </h3>

        <pre className="bg-gray-100 p-3 rounded text-xs overflow-y-auto max-h-[250px]">
            {JSON.stringify(detectionData, null, 2)}
        </pre>
        </div>
    </div>
    )}



    </>
  );
};

export default FaceDetection;
